export enum SisName {
	// stamm
	Person = 'Person',
	Task = 'Task',
	Holiday = 'holiday',
	// beweg per person
	Booking = 'booking',
	Persurl = 'persurl',
	StTagZu = 'StTagZu',
	PersStat = 'PersStat',
	VlFehl = 'VlFehl',
	PlanEvent = 'PlanEvent',
	PlanTempl = 'PlanTempl',
	TaskZu = 'TaskZu',
	// other, client-created entries
	SUM = 'SUM',
	SUM_TASK = 'SUM_TASK',
}
